export default 'recordings';
